<template>
    <BulletCard
                    v-auto-animate
                    class="d-flex flex-column"
                    :card-title="reservation.entry_summary?.identification_id || reservation.uid"
                    title-font-size="20px"
                    :bullets="[]"
                >
        <template #title>
            <router-link
                v-if="entrySearchUrl"
                :to="entrySearchUrl"
                class="entry-id-link"
                @click.stop
            >
                {{ reservation.entry_summary?.identification_id || reservation.uid }}
            </router-link>
            <span v-else>{{ reservation.entry_summary?.identification_id || reservation.uid }}</span>
        </template>
        <template #status>
            <StatusBadge :status="reservation.status" :tooltip="awaitingConfirmationTooltip" />
        </template>
        <template #default>
        <div v-auto-animate class="reservation-card-content py-3" style="overflow-wrap: break-word">
            <v-row align="start" density="compact" no-gutters>
                <v-col cols="12" sm="10">
            <div v-if="reservation.entry_summary && (loadingRouteLine || unloadingRouteLine)" class="reservation-route-block pb-3">
                <div v-if="loadingRouteLine" class="reservation-route-line">
                    <img :src="loadingPng" class="reservation-route-icon" alt="" />
                    {{ loadingRouteLine }}
                </div>
                <div v-if="unloadingRouteLine" class="reservation-route-line">
                    <img :src="unloadingPng" class="reservation-route-icon" alt="" />
                    {{ unloadingRouteLine }}
                </div>
            </div>
            <p>
                <strong>{{ $t('reservations.reservedBy') }}</strong>
                {{ reservedByText }}
            </p>
            <p>
                <strong>{{ $t('reservation.vehicleAndDriver') }}:</strong> {{ driverVehicleDisplay }} |
                {{ driverNameDisplay }}
            </p>
            <v-row v-if="showTransportOrderIcons" density="compact" class="mt-2 gap-2" align="start">
                <v-col v-if="showTransportOrderIcon" cols="auto">
                    <input
                        ref="externalGeneratedPdfInput"
                        type="file"
                        accept=".pdf"
                        style="display: none"
                        @change="onExternalGeneratedPdfSelected"
                    />
                    <template v-if="hasTransportOrder">
                        <template v-if="transportOrderViewOnly">
                            <v-tooltip v-if="transportOrderPreview?.confirmed_at" :text="$t('reservations.transportOrderConfirmedTooltip')" location="top">
                                <template #activator="{ props: tooltipProps }">
                                    <span v-bind="tooltipProps" class="d-inline-block">
                                        <ReservationDocumentCard
                                            :has-document="hasTransportOrder"
                                            :title="$t('reservations.generatedTransportOrder')"
                                            :subtitle="transportOrderSubtitle"
                                            :subtitle-date="transportOrderSubtitleDate"
                                            :subtitle-time="transportOrderSubtitleTime"
                                            :clickable="false"
                                        >
                                            <template #actions>
                                                <v-tooltip location="top">
                                                    <template #activator="{ props }">
                                                        <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.generated_pdf_url)">
                                                            mdi-eye-outline
                                                        </v-icon>
                                                    </template>
                                                    {{ $t('reservations.view') }}
                                                </v-tooltip>
                                            </template>
                                        </ReservationDocumentCard>
                                    </span>
                                </template>
                            </v-tooltip>
                            <span v-else class="d-inline-block">
                                <ReservationDocumentCard
                                    :has-document="hasTransportOrder"
                                    :title="$t('reservations.generatedTransportOrder')"
                                    :subtitle="transportOrderSubtitle"
                                            :subtitle-date="transportOrderSubtitleDate"
                                            :subtitle-time="transportOrderSubtitleTime"
                                    :clickable="false"
                                >
                                    <template #actions>
                                        <v-tooltip location="top">
                                            <template #activator="{ props }">
                                                <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.generated_pdf_url)">
                                                    mdi-eye-outline
                                                </v-icon>
                                            </template>
                                            {{ $t('reservations.view') }}
                                        </v-tooltip>
                                    </template>
                                </ReservationDocumentCard>
                            </span>
                        </template>
                        <span v-else-if="!showTransportOrderMenu" class="d-inline-block">
                            <ReservationDocumentCard
                                        :has-document="hasTransportOrder"
                                        :title="$t('reservations.generatedTransportOrder')"
                                        :subtitle="transportOrderSubtitle"
                                            :subtitle-date="transportOrderSubtitleDate"
                                            :subtitle-time="transportOrderSubtitleTime"
                                        :clickable="true"
                                        :emit-click-on-click="true"
                                        @click="openPdf(transportOrderPreview.generated_pdf_url)"
                                    >
                                        <template #actions>
                                            <v-tooltip location="top">
                                                <template #activator="{ props }">
                                                    <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.generated_pdf_url)">
                                                        mdi-eye-outline
                                                    </v-icon>
                                                </template>
                                                {{ $t('reservations.view') }}
                                            </v-tooltip>
                                        </template>
                                    </ReservationDocumentCard>
                        </span>
                        <v-menu v-else :close-on-content-click="true" location="bottom end">
                            <template #activator="{ props: menuProps }">
                                <v-tooltip :text="$t('reservations.transportOrderCardTooltip')" location="top">
                                    <template #activator="{ props: tooltipProps }">
                                        <span v-bind="{ ...menuProps, ...tooltipProps }" class="d-inline-block">
                                            <ReservationDocumentCard
                                        :has-document="hasTransportOrder"
                                        :title="$t('reservations.generatedTransportOrder')"
                                        :subtitle="transportOrderSubtitle"
                                            :subtitle-date="transportOrderSubtitleDate"
                                            :subtitle-time="transportOrderSubtitleTime"
                                        :clickable="true"
                                    >
                                        <template #actions>
                                            <v-tooltip location="top">
                                                <template #activator="{ props }">
                                                    <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.generated_pdf_url)">
                                                        mdi-eye-outline
                                                    </v-icon>
                                                </template>
                                                {{ $t('reservations.view') }}
                                            </v-tooltip>
                                        </template>
                                    </ReservationDocumentCard>
                                        </span>
                                    </template>
                                </v-tooltip>
                            </template>
                            <v-list density="compact">
                                <v-list-item v-if="transportOrderPreview?.generated_pdf_url" @click="openPdf(transportOrderPreview.generated_pdf_url)">
                                    <v-list-item-title>{{ $t('reservations.download') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="transportOrderIsExternalPdf" @click="triggerExternalGeneratedPdfUpload">
                                    <v-list-item-title>{{ $t('reservations.replaceExternalFilePdf') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="transportOrderIsExternalPdf" @click="$emit('generateTransportOrder')">
                                    <v-list-item-title>{{ $t('reservations.generateTransportOrderFileFromApp') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!transportOrderIsExternalPdf" @click="$emit('modifyTransportOrder')">
                                    <v-list-item-title>{{ $t('reservations.modify') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!transportOrderIsExternalPdf" @click="triggerExternalGeneratedPdfUpload">
                                    <v-list-item-title>{{ $t('reservations.uploadExternalFilePdf') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="$emit('sendTransportOrder')">
                                    <v-list-item-title>{{ $t('reservations.sendViaEmail') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="reserverWhatsAppUrl" @click="openWhatsApp(reserverWhatsAppUrl)">
                                    <v-list-item-title>{{ $t('reservations.sendViaWhatsApp') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-else>
                        <v-menu v-if="canGenerateTransportOrder" :close-on-content-click="true" location="bottom end">
                            <template #activator="{ props: menuProps }">
                                <v-tooltip :text="transportOrderNoFileTooltip" location="top">
                                    <template #activator="{ props: tooltipProps }">
                                        <span v-bind="{ ...menuProps, ...tooltipProps }" class="d-inline-block">
                                            <ReservationDocumentCard
                                                :has-document="hasTransportOrder"
                                                :title="$t('reservations.generatedTransportOrder')"
                                                :subtitle="transportOrderSubtitle"
                                                :subtitle-date="transportOrderSubtitleDate"
                                                :subtitle-time="transportOrderSubtitleTime"
                                                :clickable="true"
                                            />
                                        </span>
                                    </template>
                                </v-tooltip>
                            </template>
                            <v-list density="compact">
                                <v-list-item @click="$emit('generateTransportOrder')">
                                    <v-list-item-title>{{ $t('reservations.generateTransportOrder') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="triggerExternalGeneratedPdfUpload">
                                    <v-list-item-title>{{ $t('reservations.uploadExternalFilePdf') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-tooltip v-else location="top" :text="transportOrderNoFileTooltip">
                            <template #activator="{ props }">
                                <span v-bind="props" class="d-inline-block">
                                    <ReservationDocumentCard
                                        :has-document="hasTransportOrder"
                                        :title="$t('reservations.generatedTransportOrder')"
                                        :subtitle="transportOrderSubtitle"
                                        :subtitle-date="transportOrderSubtitleDate"
                                        :subtitle-time="transportOrderSubtitleTime"
                                        :clickable="false"
                                    />
                                </span>
                            </template>
                        </v-tooltip>
                    </template>
                </v-col>
                <v-col v-if="showSignedPdfIcon" cols="auto">
                    <input ref="signedPdfInput" type="file" accept=".pdf" style="display: none" @change="onSignedPdfSelected" />
                    <template v-if="signedPdfViewOnly">
                        <v-tooltip v-if="transportOrderPreview?.confirmed_at" :text="signedPdfConfirmedTooltip" location="top">
                            <template #activator="{ props: tooltipProps }">
                                <ReservationDocumentCard
                                    :has-document="!!transportOrderPreview?.has_signed_pdf"
                                    :title="$t('reservations.signedPdfInfo')"
                                    :subtitle="signedPdfSubtitle"
                                    :subtitle-date="signedPdfSubtitleDate"
                                    :subtitle-time="signedPdfSubtitleTime"
                                    :clickable="false"
                                    v-bind="tooltipProps"
                                >
                                    <template #actions>
                                        <v-tooltip location="top">
                                            <template #activator="{ props }">
                                                <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.signed_pdf_url)">
                                                    mdi-eye-outline
                                                </v-icon>
                                            </template>
                                            {{ $t('reservations.view') }}
                                        </v-tooltip>
                                    </template>
                                </ReservationDocumentCard>
                            </template>
                        </v-tooltip>
                        <ReservationDocumentCard
                            v-else
                            :has-document="!!transportOrderPreview?.has_signed_pdf"
                            :title="$t('reservations.signedPdfInfo')"
                            :subtitle="signedPdfSubtitle"
                                    :subtitle-date="signedPdfSubtitleDate"
                                    :subtitle-time="signedPdfSubtitleTime"
                            :clickable="false"
                        >
                            <template #actions>
                                <v-tooltip location="top">
                                    <template #activator="{ props }">
                                        <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.signed_pdf_url)">
                                            mdi-eye-outline
                                        </v-icon>
                                    </template>
                                    {{ $t('reservations.view') }}
                                </v-tooltip>
                            </template>
                        </ReservationDocumentCard>
                    </template>
                    <v-tooltip v-else-if="!transportOrderPreview?.has_signed_pdf" location="top" :text="signedPdfNoFileTooltip">
                        <template #activator="{ props }">
                            <span v-bind="props" class="d-inline-block">
                                <ReservationDocumentCard
                                    :has-document="!!transportOrderPreview?.has_signed_pdf"
                                    :title="$t('reservations.signedPdfInfo')"
                                    :subtitle="signedPdfSubtitle"
                                    :subtitle-date="signedPdfSubtitleDate"
                                    :subtitle-time="signedPdfSubtitleTime"
                                    :clickable="hasTransportOrder && canUploadSignedPdf"
                                    :emit-click-on-click="true"
                                    @click="onSignedPdfCardClick"
                                />
                            </span>
                        </template>
                    </v-tooltip>
                    <v-tooltip v-else-if="signedPdfUploadReplacementTooltip" location="top" :text="signedPdfUploadReplacementTooltip">
                        <template #activator="{ props }">
                            <span v-bind="props" class="d-inline-block">
                                <ReservationDocumentCard
                                    :has-document="!!transportOrderPreview?.has_signed_pdf"
                                    :title="$t('reservations.signedPdfInfo')"
                                    :subtitle="signedPdfSubtitle"
                                    :subtitle-date="signedPdfSubtitleDate"
                                    :subtitle-time="signedPdfSubtitleTime"
                                    :clickable="!isReservationDeclined"
                                    :emit-click-on-click="true"
                                    @click="onSignedPdfCardClick"
                                >
                        <template #actions>
                            <v-tooltip location="top">
                                <template #activator="{ props }">
                                    <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.signed_pdf_url)">
                                        mdi-eye-outline
                                    </v-icon>
                                </template>
                                {{ $t('reservations.view') }}
                            </v-tooltip>
                        </template>
                                </ReservationDocumentCard>
                            </span>
                        </template>
                    </v-tooltip>
                    <ReservationDocumentCard
                        v-else
                        :has-document="!!transportOrderPreview?.has_signed_pdf"
                        :title="$t('reservations.signedPdfInfo')"
                        :subtitle="signedPdfSubtitle"
                        :subtitle-date="signedPdfSubtitleDate"
                        :subtitle-time="signedPdfSubtitleTime"
                        :clickable="!isReservationDeclined"
                        :emit-click-on-click="true"
                        @click="onSignedPdfCardClick"
                    >
                        <template #actions>
                            <v-tooltip location="top">
                                <template #activator="{ props }">
                                    <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openPdf(transportOrderPreview.signed_pdf_url)">
                                        mdi-eye-outline
                                    </v-icon>
                                </template>
                                {{ $t('reservations.view') }}
                            </v-tooltip>
                        </template>
                    </ReservationDocumentCard>
                </v-col>
                <v-col v-if="showCmrInvoiceSection" cols="auto">
                    <input ref="cmrPdfInput" type="file" accept=".pdf" style="display: none" @change="onCmrPdfSelected" />
                    <v-tooltip location="top" :disabled="!cmrTooltipText" :text="cmrTooltipText">
                        <template #activator="{ props }">
                            <span v-bind="props" class="d-inline-block">
                                <ReservationDocumentCard
                                    :has-document="!!transportOrderPreview?.has_cmr_pdf"
                                    :title="$t('reservations.cmrDocumentTitle')"
                                    :subtitle="cmrSubtitle"
                                    :subtitle-date="cmrSubtitleDate"
                                    :subtitle-time="cmrSubtitleTime"
                                    :clickable="cmrCardClickable"
                                    :emit-click-on-click="true"
                                    @click="onCmrCardClick"
                                >
                                    <template #actions>
                                        <v-tooltip v-if="transportOrderPreview?.cmr_pdf_url" location="top">
                                            <template #activator="{ props: ap }">
                                                <v-icon size="small" class="cursor-pointer" v-bind="ap" @click.stop="openPdf(transportOrderPreview.cmr_pdf_url)">
                                                    mdi-eye-outline
                                                </v-icon>
                                            </template>
                                            {{ $t('reservations.view') }}
                                        </v-tooltip>
                                    </template>
                                </ReservationDocumentCard>
                            </span>
                        </template>
                    </v-tooltip>
                </v-col>
                <v-col v-if="showCmrInvoiceSection" cols="auto">
                    <input ref="invoicePdfInput" type="file" accept=".pdf" style="display: none" @change="onInvoicePdfSelected" />
                    <v-tooltip location="top" :disabled="!invoiceTooltipText" :text="invoiceTooltipText">
                        <template #activator="{ props }">
                            <span v-bind="props" class="d-inline-block">
                                <ReservationDocumentCard
                                    :has-document="!!transportOrderPreview?.has_invoice_pdf"
                                    :title="$t('reservations.invoiceDocumentTitle')"
                                    :subtitle="invoiceSubtitle"
                                    :subtitle-date="invoiceSubtitleDate"
                                    :subtitle-time="invoiceSubtitleTime"
                                    :clickable="invoiceCardClickable"
                                    :emit-click-on-click="true"
                                    @click="onInvoiceCardClick"
                                >
                                    <template #actions>
                                        <v-tooltip v-if="transportOrderPreview?.invoice_pdf_url" location="top">
                                            <template #activator="{ props: ap }">
                                                <v-icon size="small" class="cursor-pointer" v-bind="ap" @click.stop="openPdf(transportOrderPreview.invoice_pdf_url)">
                                                    mdi-eye-outline
                                                </v-icon>
                                            </template>
                                            {{ $t('reservations.view') }}
                                        </v-tooltip>
                                    </template>
                                </ReservationDocumentCard>
                            </span>
                        </template>
                    </v-tooltip>
                </v-col>
            </v-row>
            <div v-if="hasAnyCardActions" v-auto-animate class="d-flex flex-wrap align-center ga-2 mt-3">
                <template v-if="canConfirm">
                    <v-row v-if="isTruckReservation" dense class="mb-2" style="width: 100%">
                        <v-col cols="4">
                            <v-text-field
                                v-model="truckConfirmDriverName"
                                :label="$t('reservation.driverName')"
                                variant="outlined"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="truckConfirmDriverSurname"
                                :label="$t('reservation.driverSurname')"
                                variant="outlined"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="truckConfirmCarNumber"
                                :label="$t('reservation.carNumber')"
                                variant="outlined"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <template v-if="isTruckReservation">
                        <v-btn color="error" size="small" @click="$emit('decline')">
                            {{ $t('reservations.decline') }}
                        </v-btn>
                        <v-tooltip
                            :disabled="canConfirmWithDriverInfo"
                            :text="$t('reservations.truckConfirmDriverRequiredTooltip')"
                            location="top"
                        >
                            <template #activator="{ props }">
                                <span v-bind="props" class="d-inline-block">
                                    <v-btn
                                        size="small"
                                        :disabled="!canConfirmWithDriverInfo"
                                        @click="onConfirmClick"
                                    >
                                        {{ $t('reservations.confirm') }}
                                    </v-btn>
                                </span>
                            </template>
                        </v-tooltip>
                    </template>
                    <v-btn v-if="!isTruckReservation" color="error" size="small" @click="$emit('decline')">
                        {{ $t('reservations.decline') }}
                    </v-btn>
                    <v-btn v-if="!isTruckReservation" size="small" @click="onConfirmClick">
                        {{ $t('reservations.confirm') }}
                    </v-btn>
                </template>
                <template v-if="canCancel">
                    <v-tooltip
                        v-if="cancelDisabled"
                        :text="cancelDisabledTooltip"
                        location="top"
                    >
                        <template #activator="{ props }">
                            <span v-bind="props" class="d-inline-block">
                                <v-btn color="error" size="small" disabled>
                                    {{ $t('reservations.cancel') }}
                                </v-btn>
                            </span>
                        </template>
                    </v-tooltip>
                    <v-btn v-else color="error" size="small" @click="$emit('cancel')">
                        {{ $t('reservations.cancel') }}
                    </v-btn>
                </template>
                <template v-if="canConfirmTransportOrder">
                    <v-btn
                        size="small"
                        :disabled="!!transportOrderPreview?.confirmed_at"
                        @click="$emit('confirmTransportOrder')"
                    >
                        {{ $t('reservations.confirmTransportOrder') }}
                    </v-btn>
                </template>
                <template v-if="canConfirmCompleted">
                    <v-btn size="small" @click="$emit('confirmCompleted')">
                        {{ $t('reservations.confirmCompleted') }}
                    </v-btn>
                </template>
                <template v-if="showRatingForm">
                    <v-tooltip
                        location="top"
                        :open-delay="250"
                        :text="ratingTooltipSubmit"
                        :disabled="!ratingTooltipSubmit"
                    >
                        <template #activator="{ props: tipProps }">
                            <div v-bind="tipProps" class="d-flex align-center">
                                <star-rating-input
                                    v-model="quickRatingStars"
                                    :star-size="20"
                                    @update:model-value="onQuickRatingSelected"
                                />
                            </div>
                        </template>
                    </v-tooltip>
                </template>
                <template v-if="showEditRating">
                    <v-tooltip
                        location="top"
                        :open-delay="250"
                        :text="ratingTooltipEdit"
                        :disabled="!ratingTooltipEdit"
                    >
                        <template #activator="{ props: tipProps }">
                            <span v-bind="tipProps" class="d-inline-block">
                                <v-btn size="small" @click="ratingModalVisible = true">
                                    {{ $t('rating.editTitle') }}
                                </v-btn>
                            </span>
                        </template>
                    </v-tooltip>
                </template>
            </div>
            <v-dialog v-model="ratingModalVisible" max-width="500" scrim="black">
                <RatingForm
                    v-if="ratingModalVisible && (showRatingForm || showEditRating)"
                    :rated-company-id="reservation.rated_company_id"
                    :reservation-uid="reservation.uid"
                    :existing-rating="showEditRating ? reservation.existing_rating : null"
                    :initial-stars="quickRatingStars"
                    :mode="showEditRating ? 'edit' : 'create'"
                    @rated="onRatingSubmitted"
                    @cancel="onRatingCancel"
                />
            </v-dialog>
                </v-col>
                <v-col cols="12" sm="2" align-self="start">
                    <ContactSection
                        :user="contactUser"
                        :form-type="reservation.entry_summary?.form_type || entryType || 'truck'"
                    />
                </v-col>
            </v-row>
        </div>
        </template>
    </BulletCard>
</template>

<script>
import BulletCard from "@/components/display/BulletCard.vue";
import ContactSection from "@/components/ContactSection.vue";
import StatusBadge from "./StatusBadge.vue";
import RatingForm from "@/components/rating/RatingForm.vue";
import StarRatingInput from "@/components/rating/StarRatingInput.vue";
import ReservationDocumentCard from "./ReservationDocumentCard.vue";
import loadingPng from "@/assets/Loading.png";
import unloadingPng from "@/assets/Unloading.png";
import {
    formatDisplayDate,
    formatDisplayDateTime,
    formatDisplayTime,
    getRatingWindowRemainingParts,
    showAlertModal,
} from "@/utils";

const STATUSES_UPLOAD_SIGNED_BUTTON_VISIBLE = ["waiting_for_signed_to", "waiting_for_confirmation", "confirmed"];

export default {
    components: { BulletCard, ContactSection, StatusBadge, RatingForm, ReservationDocumentCard, StarRatingInput },
    data() {
        return {
            loadingPng,
            unloadingPng,
            ratingModalVisible: false,
            quickRatingStars: 0,
            truckCapacityHintShown: false,
            truckConfirmDriverName: "",
            truckConfirmDriverSurname: "",
            truckConfirmCarNumber: "",
        };
    },
    watch: {
        showTruckCapacityHint: {
            handler(show) {
                if (show && !this.truckCapacityHintShown) {
                    this.truckCapacityHintShown = true;
                    showAlertModal(this.$store, this.$t("reservations.truckCapacityHint"), "info", 10000);
                }
            },
        },
    },
    props: {
        reservation: { type: Object, required: true },
        entryType: { type: String, required: true },
        isEntryOwner: { type: Boolean, default: false },
    },
    emits: [
        "confirm",
        "decline",
        "cancel",
        "generateTransportOrder",
        "downloadTransportOrder",
        "modifyTransportOrder",
        "sendTransportOrder",
        "confirmTransportOrder",
        "confirmCompleted",
        "rated",
        "uploadSignedPdf",
        "uploadCmr",
        "uploadInvoice",
        "uploadGeneratedTransportOrder",
    ],
    computed: {
        contactUser() {
            if (this.isEntryOwner) return this.reservation.reserved_by_user || null;
            return this.reservation.owner_user || null;
        },
        transportOrderPreview() {
            return this.reservation.transport_order_preview || null;
        },
        canConfirmTransportOrder() {
            if (this.reservation.status !== "waiting_for_confirmation" || !this.reservation.has_transport_order || !this.transportOrderPreview?.has_signed_pdf) return false;
            return this.isTruckReservation ? !this.isEntryOwner : this.isEntryOwner;
        },
        loadingRouteLine() {
            const entrySummary = this.reservation.entry_summary;
            if (!entrySummary) return "";
            const base = entrySummary.loading_summary || "";
            const timePart = entrySummary.loading_scheduled_date && entrySummary.loading_scheduled_time
                ? `${entrySummary.loading_scheduled_date}, ${entrySummary.loading_scheduled_time}`
                : entrySummary.loading_scheduled_date || entrySummary.loading_scheduled_time || "";
            return base && timePart ? `${base} | ${timePart}` : base || timePart || "";
        },
        unloadingRouteLine() {
            const entrySummary = this.reservation.entry_summary;
            if (!entrySummary) return "";
            const base = entrySummary.unloading_summary || "";
            const timePart = entrySummary.unloading_scheduled_date && entrySummary.unloading_scheduled_time
                ? `${entrySummary.unloading_scheduled_date}, ${entrySummary.unloading_scheduled_time}`
                : entrySummary.unloading_scheduled_date || entrySummary.unloading_scheduled_time || "";
            return base && timePart ? `${base} | ${timePart}` : base || timePart || "";
        },
        reservedByText() {
            const reservedByUser = this.reservation.reserved_by_user;
            const reservedByCompany = this.reservation.reserved_by_company;
            if (!reservedByUser) return "-";
            const name = [reservedByUser.first_name, reservedByUser.last_name].filter(Boolean).join(" ") || "-";
            // const email = reservedByUser.email || "";
            const companyName = reservedByCompany?.name || "";
            return `${name} ${companyName ? ` - ${companyName}` : ""}`;
        },
        isTruckReservation() {
            return (this.reservation.entry_summary?.form_type || this.entryType) === "truck";
        },
        driverVehicleDisplay() {
            if (this.isTruckReservation && !(this.reservation.car_number || "").trim()) {
                return this.$t("reservation.toBeFilledByOwner");
            }
            return this.reservation.car_number || "—";
        },
        driverNameDisplay() {
            if (this.isTruckReservation && !(this.reservation.driver_name || "").trim() && !(this.reservation.driver_surname || "").trim()) {
                return this.$t("reservation.toBeFilledByOwner");
            }
            const name = [this.reservation.driver_name, this.reservation.driver_surname].filter(Boolean).join(" ").trim();
            return name || "—";
        },
        reserverWhatsAppUrl() {
            const user = this.reservation.reserved_by_user;
            if (!user?.phone || !user?.hasWhatsApp) return null;
            const prefix = (user.phone_prefix || "").replace(/\D/g, "") || "";
            let number = (user.phone || "").replace(/\D/g, "") || "";
            if (!number) return null;
            if (prefix) number = number.replace(/^0+/, "") || number;
            const full = prefix + number;
            const pdfUrl = this.transportOrderPreview?.generated_pdf_url;
            const text = pdfUrl
                ? encodeURIComponent(this.$t("reservations.whatsAppMessageWithPdf", { url: pdfUrl }))
                : "";
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (isMobile) {
                return `https://wa.me/${full}${text ? `?text=${text}` : ""}`;
            }
            return `https://web.whatsapp.com/send?phone=${full}${text ? `&text=${text}` : ""}`;
        },
        canConfirm() {
            return this.isEntryOwner && this.reservation.status === "pending";
        },
        canConfirmWithDriverInfo() {
            if (!this.isTruckReservation) return true;
            return (
                (this.truckConfirmDriverName || "").trim() &&
                (this.truckConfirmDriverSurname || "").trim() &&
                (this.truckConfirmCarNumber || "").trim()
            );
        },
        canCancel() {
            if (["in_progress", "completed_and_awaiting_confirmation", "completed_and_confirmed", "declined"].includes(this.reservation.status)) return false;
            if (this.isEntryOwner && this.reservation.status === "pending") return false;
            return true;
        },
        cancelDisabled() {
            return !!this.transportOrderPreview?.confirmed_at;
        },
        cancelDisabledTooltip() {
            const name = this.transportOrderPreview?.confirmed_by_company_name || "-";
            return this.$t("reservations.cancelDisabledTooltip", { companyName: name });
        },
        canConfirmCompleted() {
            if (this.reservation.status !== "completed_and_awaiting_confirmation") return false;
            const isOwner = this.isEntryOwner;
            const isReserver = !this.isEntryOwner;
            if (isOwner && this.reservation.completed_confirmed_by_owner) return false;
            if (isReserver && this.reservation.completed_confirmed_by_reserver) return false;
            return true;
        },
        awaitingConfirmationTooltip() {
            if (this.reservation.status !== "completed_and_awaiting_confirmation") return "";
            const ownerName = this.reservation.owner_company_name || "—";
            const reserverName = this.reservation.reserved_by_company?.name || "—";
            const bothConfirmed = this.reservation.completed_confirmed_by_owner && this.reservation.completed_confirmed_by_reserver;
            if (bothConfirmed) return "";
            const neitherConfirmed = !this.reservation.completed_confirmed_by_owner && !this.reservation.completed_confirmed_by_reserver;
            if (neitherConfirmed) {
                return this.$t("reservations.awaitingConfirmationTooltipBoth", { owner: ownerName, reserver: reserverName });
            }
            if (!this.reservation.completed_confirmed_by_owner) {
                return this.$t("reservations.awaitingConfirmationTooltipFrom", { company: ownerName });
            }
            return this.$t("reservations.awaitingConfirmationTooltipFrom", { company: reserverName });
        },
        showRatingForm() {
            if (!this.reservation.rated_company_id) return false;
            if (this.reservation.user_has_rated) return false;
            if (typeof this.reservation.rating_can_submit === "boolean") {
                return this.reservation.rating_can_submit;
            }
            const statusOk = ["completed_and_awaiting_confirmation", "completed_and_confirmed"].includes(this.reservation.status);
            if (!statusOk) return false;
            const ownerCanRate = this.isEntryOwner && this.reservation.completed_confirmed_by_owner;
            const reserverCanRate = !this.isEntryOwner && this.reservation.completed_confirmed_by_reserver;
            return ownerCanRate || reserverCanRate;
        },
        ratingTooltipSubmit() {
            return this.ratingWindowTooltipText(false);
        },
        ratingTooltipEdit() {
            return this.ratingWindowTooltipText(true);
        },
        showEditRating() {
            return (
                this.reservation.user_has_rated &&
                this.reservation.existing_rating?.can_edit &&
                this.reservation.rated_company_id
            );
        },
        showTruckCapacityHint() {
            return (
                this.isEntryOwner &&
                this.entryType === "truck" &&
                this.reservation.has_transport_order &&
                !!this.transportOrderPreview?.confirmed_at
            );
        },
        hasAnyCardActions() {
            return (
                this.canConfirm ||
                this.canCancel ||
                this.canConfirmTransportOrder ||
                this.canConfirmCompleted ||
                this.showRatingForm ||
                this.showEditRating
            );
        },
        showTransportOrderIcons() {
            return this.showTransportOrderIcon || this.showSignedPdfIcon || this.showCmrInvoiceSection;
        },
        showCmrInvoiceSection() {
            if (!this.reservation.has_transport_order || !this.transportOrderPreview) return false;
            if (this.isReservationDeclined) return false;
            return ["confirmed", "in_progress", "completed_and_awaiting_confirmation", "completed_and_confirmed"].includes(
                this.reservation.status
            );
        },
        canUploadCmrInvoice() {
            return (
                this.canUploadSignedPdf &&
                this.showCmrInvoiceSection &&
                this.reservation.status === "confirmed"
            );
        },
        cmrSubtitle() {
            if (this.transportOrderPreview?.has_cmr_pdf) {
                const date = this.transportOrderPreview?.cmr_uploaded_at;
                return date ? formatDisplayDateTime(date) : "";
            }
            return this.$t("reservations.noFilePresent");
        },
        cmrSubtitleDate() {
            if (!this.transportOrderPreview?.has_cmr_pdf) return null;
            const date = this.transportOrderPreview?.cmr_uploaded_at;
            return date ? formatDisplayDate(date) : null;
        },
        cmrSubtitleTime() {
            if (!this.transportOrderPreview?.has_cmr_pdf) return null;
            const date = this.transportOrderPreview?.cmr_uploaded_at;
            return date ? formatDisplayTime(date) : null;
        },
        invoiceSubtitle() {
            if (this.transportOrderPreview?.has_invoice_pdf) {
                const date = this.transportOrderPreview?.invoice_uploaded_at;
                return date ? formatDisplayDateTime(date) : "";
            }
            return this.$t("reservations.noFilePresent");
        },
        invoiceSubtitleDate() {
            if (!this.transportOrderPreview?.has_invoice_pdf) return null;
            const date = this.transportOrderPreview?.invoice_uploaded_at;
            return date ? formatDisplayDate(date) : null;
        },
        invoiceSubtitleTime() {
            if (!this.transportOrderPreview?.has_invoice_pdf) return null;
            const date = this.transportOrderPreview?.invoice_uploaded_at;
            return date ? formatDisplayTime(date) : null;
        },
        cmrCardClickable() {
            if (this.isReservationDeclined) return false;
            if (this.canUploadCmrInvoice) return true;
            return !!this.transportOrderPreview?.cmr_pdf_url;
        },
        invoiceCardClickable() {
            if (this.isReservationDeclined) return false;
            if (this.canUploadCmrInvoice) return true;
            return !!this.transportOrderPreview?.invoice_pdf_url;
        },
        cmrTooltipText() {
            if (!this.showCmrInvoiceSection) return "";
            const company =
                (this.isTruckReservation ? this.reservation.owner_company_name : this.reservation.reserved_by_company?.name) || "—";
            const hasCmr = this.transportOrderPreview?.has_cmr_pdf;
            const confirmed = this.reservation.status === "confirmed";
            if (!hasCmr && !confirmed) {
                return this.$t("reservations.cmrInvoiceUploadClosed");
            }
            if (!hasCmr && !this.canUploadCmrInvoice) {
                return this.$t("reservations.waitForCompanyToUploadCmr", { company });
            }
            if (!hasCmr && this.canUploadCmrInvoice) {
                return this.$t("reservations.uploadCmr");
            }
            if (hasCmr && this.canUploadCmrInvoice) {
                return this.$t("reservations.clickCardToUploadNewFile");
            }
            return "";
        },
        invoiceTooltipText() {
            if (!this.showCmrInvoiceSection) return "";
            const company =
                (this.isTruckReservation ? this.reservation.owner_company_name : this.reservation.reserved_by_company?.name) || "—";
            const hasInv = this.transportOrderPreview?.has_invoice_pdf;
            const confirmed = this.reservation.status === "confirmed";
            if (!hasInv && !confirmed) {
                return this.$t("reservations.cmrInvoiceUploadClosed");
            }
            if (!hasInv && !this.canUploadCmrInvoice) {
                return this.$t("reservations.waitForCompanyToUploadInvoice", { company });
            }
            if (!hasInv && this.canUploadCmrInvoice) {
                return this.$t("reservations.uploadInvoice");
            }
            if (hasInv && this.canUploadCmrInvoice) {
                return this.$t("reservations.clickCardToUploadNewFile");
            }
            return "";
        },
        showTransportOrderIcon() {
            const waitingForTo = this.reservation.status === "waiting_for_to";
            const ownerNeedsGenerate = this.isEntryOwner && waitingForTo && !this.isTruckReservation;
            const reserverNeedsGenerate = !this.isEntryOwner && waitingForTo && this.isTruckReservation;
            const ownerWaitsForTo = this.isEntryOwner && waitingForTo && this.isTruckReservation;
            const reserverWaitsForTo = !this.isEntryOwner && waitingForTo && !this.isTruckReservation;
            const canViewTransportOrder = this.reservation.has_transport_order;
            return ownerNeedsGenerate || reserverNeedsGenerate || ownerWaitsForTo || reserverWaitsForTo || canViewTransportOrder;
        },
        showSignedPdfIcon() {
            const hasTransportOrder = this.reservation.has_transport_order && this.transportOrderPreview;
            const hasSignedPdf = this.transportOrderPreview?.has_signed_pdf;

            // Once signed PDF exists, keep it visible for the whole lifecycle
            if (hasTransportOrder && hasSignedPdf) return true;

            // Show for upload flow (before signed PDF exists)
            if (!STATUSES_UPLOAD_SIGNED_BUTTON_VISIBLE.includes(this.reservation.status)) return false;
            const waitingForTo = this.reservation.status === "waiting_for_to";
            const ownerWaitsForTo = this.isEntryOwner && waitingForTo && this.isTruckReservation;
            const reserverWaitsForTo = !this.isEntryOwner && waitingForTo && !this.isTruckReservation;
            return hasTransportOrder || ownerWaitsForTo || reserverWaitsForTo;
        },
        hasTransportOrder() {
            return !!this.reservation.has_transport_order;
        },
        transportOrderSubtitle() {
            if (this.hasTransportOrder && this.transportOrderPreview?.generated_at) {
                return formatDisplayDateTime(this.transportOrderPreview.generated_at);
            }
            return this.$t("reservations.noFilePresent");
        },
        transportOrderSubtitleDate() {
            if (this.hasTransportOrder && this.transportOrderPreview?.generated_at) {
                return formatDisplayDate(this.transportOrderPreview.generated_at);
            }
            return null;
        },
        transportOrderSubtitleTime() {
            if (this.hasTransportOrder && this.transportOrderPreview?.generated_at) {
                return formatDisplayTime(this.transportOrderPreview.generated_at);
            }
            return null;
        },
        signedPdfSubtitle() {
            if (this.transportOrderPreview?.confirmed_at || this.transportOrderPreview?.has_signed_pdf) {
                const date = this.transportOrderPreview?.signed_uploaded_at;
                return date ? formatDisplayDateTime(date) : "";
            }
            return this.$t("reservations.noFilePresent");
        },
        signedPdfSubtitleDate() {
            if (!(this.transportOrderPreview?.confirmed_at || this.transportOrderPreview?.has_signed_pdf)) return null;
            const date = this.transportOrderPreview?.signed_uploaded_at;
            return date ? formatDisplayDate(date) : null;
        },
        signedPdfSubtitleTime() {
            if (!(this.transportOrderPreview?.confirmed_at || this.transportOrderPreview?.has_signed_pdf)) return null;
            const date = this.transportOrderPreview?.signed_uploaded_at;
            return date ? formatDisplayTime(date) : null;
        },
        entrySearchUrl() {
            const id = this.reservation.entry_summary?.identification_id;
            if (!id) return null;
            const completed = ["completed_and_awaiting_confirmation", "completed_and_confirmed"].includes(this.reservation.status);
            if (completed) return null;
            const path = this.entryType === "truck" ? "/dashboard/search-trucks" : "/dashboard/search-wares";
            return { path, query: { identificationId: id } };
        },
        signedPdfIconColor() {
            if (this.transportOrderPreview?.confirmed_at) return "info";
            return this.transportOrderPreview?.has_signed_pdf ? "success" : "warning";
        },
        signedPdfIconDisabled() {
            return !!this.transportOrderPreview?.confirmed_at;
        },
        isReservationDeclined() {
            return this.reservation.status === "declined";
        },
        transportOrderViewOnly() {
            return !!this.transportOrderPreview?.confirmed_at || this.isReservationDeclined;
        },
        signedPdfViewOnly() {
            return this.signedPdfIconDisabled || this.isReservationDeclined;
        },
        canGenerateTransportOrder() {
            return (this.isTruckReservation ? !this.isEntryOwner : this.isEntryOwner) && !this.isReservationDeclined;
        },
        showTransportOrderMenu() {
            return this.canGenerateTransportOrder;
        },
        transportOrderIsExternalPdf() {
            return this.transportOrderPreview?.transport_order_source === "external_pdf";
        },
        canUploadSignedPdf() {
            return (this.isTruckReservation ? this.isEntryOwner : !this.isEntryOwner) && !this.isReservationDeclined;
        },
        transportOrderNoFileTooltip() {
            if (this.canGenerateTransportOrder) return this.$t("reservations.generateTransportOrder");
            const company = this.isTruckReservation ? this.reservation.reserved_by_company?.name : this.reservation.owner_company_name;
            return this.$t("reservations.waitForCompanyToGenerateTransportOrder", { company: company || "—" });
        },
        signedPdfConfirmedTooltip() {
            if (!this.transportOrderPreview?.confirmed_at) return "";
            const isConfirmingParty = this.isTruckReservation ? !this.isEntryOwner : this.isEntryOwner;
            if (isConfirmingParty) return this.$t("reservations.youConfirmedSignedTransportOrderTooltip");
            const companyName = this.transportOrderPreview?.confirmed_by_company_name || "-";
            return this.$t("reservations.uploadSignedPdfDisabledTooltip", { companyName });
        },
        signedPdfNoFileTooltip() {
            const uploaderCompany = this.isTruckReservation ? this.reservation.owner_company_name : this.reservation.reserved_by_company?.name;
            const company = uploaderCompany || "—";
            if (!this.hasTransportOrder) {
                return this.$t("reservations.signedPdfNeedsUploadByCompany", { company });
            }
            if (!this.canUploadSignedPdf) {
                return this.$t("reservations.waitForCompanyToUploadSignedPdf", { company });
            }
            return this.$t("reservations.uploadSignedPdf");
        },
        signedPdfUploadReplacementTooltip() {
            if (!this.transportOrderPreview?.has_signed_pdf || this.transportOrderPreview?.confirmed_at) return "";
            if (!this.canUploadSignedPdf) return "";
            return this.$t("reservations.clickCardToUploadNewFile");
        },
    },
    methods: {
        /**
         * @param {boolean} forEditTooltip - true = edit rating, false = first-time submit
         */
        ratingWindowTooltipText(forEditTooltip) {
            const remaining = getRatingWindowRemainingParts(this.reservation.rating_window_expires_at);
            if (remaining === null) {
                return "";
            }
            if (remaining.expired) {
                return this.$t("rating.tooltipWindowExpired");
            }
            const timeLabel = this.$t("rating.tooltipTimeFormat", {
                hours: remaining.hours,
                minutes: remaining.minutes,
            });
            if (forEditTooltip) {
                return this.$t("rating.tooltipEditRating", { time: timeLabel });
            }
            return this.$t("rating.tooltipSubmitRating", { time: timeLabel });
        },
        onConfirmClick() {
            if (this.isTruckReservation && !this.canConfirmWithDriverInfo) return;
            const payload = this.isTruckReservation
                ? {
                      driver_name: (this.truckConfirmDriverName || "").trim(),
                      driver_surname: (this.truckConfirmDriverSurname || "").trim(),
                      car_number: (this.truckConfirmCarNumber || "").trim(),
                  }
                : undefined;
            this.$emit("confirm", payload);
        },
        openWhatsApp(url) {
            if (url) window.open(url, "_blank", "noopener,noreferrer");
        },
        openPdf(url) {
            if (url) window.open(url, "_blank", "noopener,noreferrer");
        },
        triggerExternalGeneratedPdfUpload() {
            this.$refs.externalGeneratedPdfInput?.click();
        },
        onExternalGeneratedPdfSelected(event) {
            const file = event.target?.files?.[0];
            if (file) this.$emit("uploadGeneratedTransportOrder", file);
            event.target.value = "";
        },
        onSignedPdfCardClick() {
            if (this.signedPdfIconDisabled || this.isReservationDeclined) return;
            if (this.transportOrderPreview?.has_signed_pdf) {
                // Has signed PDF, not yet confirmed - uploader can replace, others can view
                if (this.canUploadSignedPdf) {
                    this.$refs.signedPdfInput?.click();
                } else if (this.transportOrderPreview?.signed_pdf_url) {
                    this.openPdf(this.transportOrderPreview.signed_pdf_url);
                }
            } else {
                // No signed PDF yet - carrier uploads (reserver for ware, entry owner for truck)
                if (!this.hasTransportOrder || !this.canUploadSignedPdf) return;
                this.$refs.signedPdfInput?.click();
            }
        },
        onQuickRatingSelected(value) {
            if (value >= 1 && value <= 5) {
                this.ratingModalVisible = true;
            }
        },
        onRatingSubmitted() {
            this.ratingModalVisible = false;
            this.quickRatingStars = 0;
            this.$emit("rated");
        },
        onRatingCancel() {
            this.ratingModalVisible = false;
            if (this.showRatingForm) {
                this.quickRatingStars = 0;
            }
        },
        onTransportOrderCardClick() {
            if (this.hasTransportOrder && this.transportOrderPreview?.generated_pdf_url) {
                this.openPdf(this.transportOrderPreview.generated_pdf_url);
            } else if (!this.hasTransportOrder) {
                this.$emit("generateTransportOrder");
            }
        },
        onSignedPdfSelected(event) {
            const file = event.target?.files?.[0];
            if (file) this.$emit("uploadSignedPdf", file);
            event.target.value = "";
        },
        onCmrCardClick() {
            if (this.isReservationDeclined) return;
            if (this.canUploadCmrInvoice) {
                this.$refs.cmrPdfInput?.click();
                return;
            }
            if (this.transportOrderPreview?.cmr_pdf_url) {
                this.openPdf(this.transportOrderPreview.cmr_pdf_url);
            }
        },
        onInvoiceCardClick() {
            if (this.isReservationDeclined) return;
            if (this.canUploadCmrInvoice) {
                this.$refs.invoicePdfInput?.click();
                return;
            }
            if (this.transportOrderPreview?.invoice_pdf_url) {
                this.openPdf(this.transportOrderPreview.invoice_pdf_url);
            }
        },
        onCmrPdfSelected(event) {
            const file = event.target?.files?.[0];
            if (file) this.$emit("uploadCmr", file);
            event.target.value = "";
        },
        onInvoicePdfSelected(event) {
            const file = event.target?.files?.[0];
            if (file) this.$emit("uploadInvoice", file);
            event.target.value = "";
        },
    },
};
</script>

<style scoped>
.reservation-card-content {
    font-size: 1rem;
}

.entry-id-link {
    color: #FFEB3B;
    text-decoration: none;
}
.entry-id-link:hover {
    color: inherit;
    text-decoration: none;
}

.cursor-pointer {
    cursor: pointer;
}

.reservation-route-line {
    line-height: 1.5;
}

.reservation-route-icon {
    width: 60px;
    height: 18px;
    vertical-align: top;
}
</style>
